<template>
    <div id="rowcontainer" class="row "
         v-bind:class="!product.hideQualitySelection && (!product.productConfiguratorType || product.productConfiguratorType === 'quality_buttons') && (qualities.length > 1) ? 'headergeneral' : ''">
        <div id="productimg" class="col-xs-4 col-md-5 hidden-xs hidden-sm no-padding prod-img">
            <img :data-src="image.url" :alt="image.alt" class="lazy main-image">
            <template v-if="!featureFlags.show_trust_image && qualityData.bannerImage.url!==''">
                <a :href="qualityData.bannerImageLink" target="_blank">
                    <img :data-src="qualityData.bannerImage.url" :alt="qualityData.bannerImage.alt"
                         class="banner-image lazy">
                </a>
            </template>
            <template v-if="featureFlags.show_trust_image">
                <div :class="[`grid-col-${trustBadges.length}` , 'my-10']">
                    <template v-if="trustImage">
                        <template v-for="(trustBadge, index) in trustBadges">
                            <div class="width-trust-badge" :key="'repeatable-' + index">
                                <template v-if="trustBadge.trust_link">
                                    <a :href="trustBadge.trust_link" target="_blank">
                                        <img :src="trustBadge.trust_image.url" class="image-fluid lazy">
                                    </a>
                                </template>
                                <template v-else>
                                    <img :src="trustBadge.trust_image.url" class="image-fluid lazy">
                                </template>
                            </div>
                        </template>
                    </template>
                </div>
                <div v-if="bannerLogo" :class="[`grid-col-${trustBadges.length}`]">
                    <a :href="qualityData.bannerImageLink" target="_blank">
                        <img :src="qualityData.bannerImage.url" :alt="qualityData.bannerImage.alt" class="lazy">
                    </a>
                </div>
            </template>
            <div class="eqlink" v-if="getFeatureFlag('hasEquipmentItems')">
                <a href="#furtherDetailsBlockElement">
                    {{ lang.insured_devices }}
                </a>
            </div>
            <div v-if="showFaqLink">
                <a href="#faqBlockElement">{{ lang.common_questions }}</a>
            </div>
            <template v-if="qualityData.trustpilotImage.url">
                <img :src="qualityData.trustpilotImage.url" :alt="qualityData.trustpilotImage.alt" class="lazy"/>
            </template>
        </div>
        <div id="quality" class="col-xs-12 col-md-7">
            <div class="row qualitynav"
                 v-if="!product.hideQualitySelection && (!product.productConfiguratorType || product.productConfiguratorType === 'quality_buttons') && (qualities.length > 1)">
                <ul class="nav nav-tabs">
                    <li role="presentation" v-for="(q) in qualities" :key="q.id"
                        :class="{ active: q === quality }" @click="selectQuality(q)">
                        <a href="#">{{ q.name }}</a>
                    </li>
                </ul>
            </div>
            <div class="row qualitycontent">
                <div class="col-xs-12">
                    <div class="visible-xs visible-sm bottom-buffer">
                        <template v-if="!featureFlags.show_trust_image && qualityData.bannerImage.url!==''">
                            <a :href="qualityData.bannerImageLink" target="_blank">
                                <img :data-src="qualityData.bannerImage.url" :alt="qualityData.bannerImage.alt"
                                     class="row banner-image lazy">
                            </a>
                        </template>
                        <template v-if="featureFlags.show_trust_image">
                            <template v-if="trustImage">
                                <template v-for="(trustBadge, index) in trustBadges">
                                    <div class="width-trust-badge" :key="'badge-' + index">
                                        <template v-if="trustBadge.trust_link">
                                            <a :href="trustBadge.trust_link" target="_blank">
                                                <img :src="trustBadge.trust_image.url" class="row banner-image lazy">
                                            </a>
                                        </template>
                                        <template v-else>
                                            <img :src="trustBadge.trust_image.url" class="row banner-image lazy">
                                        </template>
                                    </div>
                                </template>
                            </template>
                            <template v-if="bannerLogo">
                                <a :href="qualityData.bannerImageLink" target="_blank">
                                    <img :src="qualityData.bannerImage.url" :alt="qualityData.bannerImage.alt"
                                         class="row banner-image lazy">
                                </a>
                            </template>
                        </template>
                    </div>
                    <div class="voucher-image"
                         v-if="!getFeatureFlag('hideGeneralVoucherImage') && salesChannel === 'B2B'">
                        <div class="bottom-buffer" v-if="generalVoucherImage !== null">
                            <img :src="generalVoucherImage" id="voucherImage" class="lazy">
                        </div>
                        <!--<img class="bottom-buffer" v-else-if="prismicProduct && prismicProductImage && !getFeatureFlag('hideVoucherImage')" :src="prismicProductImage.url" :alt="prismicProductImage.alt">-->
                    </div>
                    <div v-if="!getFeatureFlag('hideVoucherImage') && salesChannel !== 'B2B'" class="voucher-image">
                        <div v-if="generalVoucherImage !== null" class="bottom-buffer">
                            <img id="voucherImageWebshop" :src="generalVoucherImage" class="lazy">
                        </div>
                    </div>
                    <span v-html="qualityDetails.highlights"></span>
                </div>
                <div class="col-xs-12 col-md-6" v-if="media.riskCarrierUrl">
                    <span v-html="media.label"></span>
                    <a :href="media.riskCarrierUrl">
                        <img class="carrier-icon lazy" :src="media.image.url" id="riskCarrierImage">
                    </a>
                </div>
                <div v-if="furtherProducts && furtherProducts.headline && furtherProducts.products.length > 0"
                     class="col-xs-12 top-margin">
                    <div v-html="furtherProducts.headline"></div>
                    <div v-for="(product, index) in furtherProducts.products" :key="'product-' + index">
                        <a v-if="product.url" :href="'/produkte/'+product.url">{{ product.title }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
      props: ['lang','productId', 'product', 'media', 'qualityData', 'initialQuality', 'featureFlags', 'furtherProducts', 'faq', 'navigation', 'voucherGeneral', 'checkoutParameters', 'defaultSalesChannel', 'salesChannel', 'trustBadges'],
      data: function () {
          return {
              qualityId: this.initialQuality,
              quality: {}
          }
      },
      computed: {
          qualities: function () {
              return this.product.qualities ? this.product.qualities.sort((a, b) => a.priority - b.priority) : [];
          },
          qualityDetails: function () {
              return this.qualityData.qualities.find(it => it.uuid === this.qualityId) || this.qualityData.qualities[0] || {image: {}};
          },
          image: function () {
              return this.qualityDetails.image.url !== '' && this.qualityDetails.image.url !== undefined ?
                  this.qualityDetails.image : this.qualityData.productImage;
          },
          bannerLogo:function (){
              return this.qualityData.bannerImage.url !== '' ? true : false;
          },
          trustImage:function (){
            for(let image in this.trustBadges){
               return this.trustBadges[image].trust_image.url !== '' ? true : false;
            }
          },
          showFaqLink: function () {
              return this.faq && this.faq.length >= 0;
          },
          prismicProduct: function () {
              for (let attribute in this.navigation) {
                  if (Object.keys(this.navigation).includes(attribute)) {
                      if (this.navigation[attribute].uuid === this.productId) {
                          return this.navigation[attribute];
                      }
                  }
              }

              return null;
          },
          prismicProductImage: function () {
              return this.prismicProduct && this.prismicProduct.image ? this.prismicProduct.image : null;
          },
          generalVoucherImage: function () {
              var path = location.pathname;
              var voucherImage = null;
              for (let category in this.navigation.submenus) {
                  this.navigation.submenus[category].forEach(function (submenu) {
                      submenu.subitems.forEach(function(subitem){
                          if (subitem.slug == path) voucherImage = subitem.voucher;
                      });
                  });
              }
              return voucherImage;
          },
      },
      watch: {
          'qualityId': {
              immediate: true,
              handler: function () {
                  this.selectQuality(this.qualities.find(it => it.id === this.qualityId));
              }
          },
          'quality': function () {
              this.$emit('quality-changed', this.quality.id);
          }
      },
      methods: {
          selectQuality: function (quality) {
              this.quality = quality;
          },
          getFeatureFlag: function (key) {
              return this.featureFlags[key];
          },
        getQualityData: function (key) {
          return this.qualityData[key];
        },
      },
  };
</script>

<style scoped>
  .banner-image {
    width: 50%;
    margin-bottom: 5px;
  }
  .image-fluid {
    max-width: 100%;
    height: auto;
  }
  .my-10{
    margin: 10px 0 10px 0;
  }
  .grid-col-4 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 10px;
  }
  .grid-col-3 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 10px;
  }
  .grid-col-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 10px;
  }
  .grid-col-1 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 10px;
  }
  .width-trust-badge {
    width:100%;
  }
  #voucherImageWebshop {
      max-width: 100%;
  }
</style>
